import type { PractitionerDto } from "@repo/data-store";
import { Badge } from "@repo/ui/components/ui/badge";
import { cn } from "@repo/ui/lib/utils";

export type RoleBadgeRole = NonNullable<PractitionerDto["role"]> | "agent";

const ROLE_CONFIG: Record<RoleBadgeRole, { label: string; bg: string; text: string }> = {
  clinician: { label: "Clinician", bg: "bg-blue-100 dark:bg-blue-900/30", text: "text-blue-700 dark:text-blue-300" },
  assistant: {
    label: "Assistant",
    bg: "bg-purple-100 dark:bg-purple-900/30",
    text: "text-purple-700 dark:text-purple-300",
  },
  staff: { label: "Staff", bg: "bg-green-100 dark:bg-green-900/30", text: "text-green-700 dark:text-green-300" },
  admin: { label: "Admin", bg: "bg-amber-100 dark:bg-amber-900/30", text: "text-amber-700 dark:text-amber-300" },
  agent: { label: "Agent", bg: "bg-cyan-100 dark:bg-cyan-900/30", text: "text-cyan-700 dark:text-cyan-300" },
};

export function RoleBadge({ role }: { role: RoleBadgeRole }) {
  const config = ROLE_CONFIG[role];
  return <Badge className={cn(config.bg, config.text, "border-transparent")}>{config.label}</Badge>;
}
